import React from "react";

interface ProjectionsProps {
  fill?: string; // Optional prop for fill color
}

const ProjectionsIcon: React.FC<ProjectionsProps> = ({ fill = "#00132E" }) => (
  <svg
    // width="428"
    // height="397"
    viewBox="0 0 428 397"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_19465_95338)">
      <path
        d="M215.5 396.66C279.918 396.66 332.14 382.544 332.14 365.13C332.14 347.717 279.918 333.6 215.5 333.6C151.081 333.6 98.86 347.717 98.86 365.13C98.86 382.544 151.081 396.66 215.5 396.66Z"
        fill={fill}
      />
      <path
        d="M110.96 372.6C109.68 372.6 108.37 372.39 107.09 371.96C100.82 369.82 97.46 363.01 99.6 356.73L119.81 297.37C121.95 291.09 128.76 287.74 135.04 289.88C141.31 292.02 144.67 298.83 142.53 305.11L122.32 364.47C120.62 369.46 115.96 372.61 110.96 372.61V372.6Z"
        fill={fill}
      />
      <path
        d="M321.25 372.6C316.25 372.6 311.59 369.46 309.89 364.46L289.68 305.1C287.55 298.83 290.9 292.01 297.17 289.87C303.44 287.74 310.26 291.09 312.4 297.36L332.61 356.72C334.74 362.99 331.39 369.81 325.12 371.95C323.84 372.39 322.54 372.59 321.25 372.59V372.6Z"
        fill={fill}
      />
      <path
        d="M216.52 335.8C123.94 335.8 48.62 260.48 48.62 167.9C48.62 75.32 123.94 0 216.52 0C309.1 0 384.42 75.32 384.42 167.9C384.42 260.48 309.1 335.8 216.52 335.8ZM216.52 24C137.17 24 72.62 88.55 72.62 167.9C72.62 247.25 137.17 311.8 216.52 311.8C295.87 311.8 360.42 247.25 360.42 167.9C360.42 88.55 295.86 24 216.52 24Z"
        fill={fill}
      />
      <path
        d="M283.46 263.2C290.08 271.11 274.7 279.62 268.49 282.42C241.01 294.8 198.8 294.31 170.64 284.3C162.44 281.39 150.37 276.4 147.95 267.41C148.15 259.65 173.04 254.81 179.15 253.81C203.31 249.82 230.94 250.03 255.1 253.99C260.63 254.9 280.32 259.46 283.46 263.21V263.2Z"
        fill={fill}
      />
      <path
        d="M257.17 56.1302C262.72 49.7102 272.41 56.4302 278.48 59.8502C313.98 79.8702 340.94 119.13 343.31 160.23C343.44 162.56 345.04 178.18 338.99 173.67C336.76 172.01 333.9 152.37 332.33 147.48C320.77 111.44 294.23 82.9202 259.99 67.6802C255.75 65.7902 254.07 60.4102 256.76 56.6202C256.89 56.4402 257.02 56.2802 257.15 56.1202L257.17 56.1302Z"
        fill={fill}
      />
      <path
        d="M213.79 45.2001C216.86 42.4001 221.95 41.9301 226.06 42.1801C229.92 42.4101 234.15 43.0301 237.48 45.1301C240.29 46.8901 241.12 49.4601 240.73 52.6201C240.41 55.2401 239.84 58.6601 237.34 60.1101C234.96 61.4901 231.95 61.0401 229.35 60.7101C226.32 60.3201 223.24 59.9601 220.24 59.3601C217.81 58.8701 214.83 58.0801 212.97 56.3201C211.14 54.5901 210.76 51.6501 211.35 49.3101C211.79 47.5801 212.64 46.2401 213.77 45.2101L213.79 45.2001Z"
        fill={fill}
      />
      <path
        d="M424.02 93.25C423.47 93.76 422.76 94.1501 421.95 94.3301C419.48 94.8801 416.88 95.1301 414.9 96.9001C410.65 100.68 411.85 113.17 404.98 112.53C400.32 112.1 400.82 101.96 397.78 98.56C394.77 95.19 385.49 95.34 385.5 90.84C385.51 86.34 395.31 85.63 398.23 82.46C400.83 79.65 400.67 75.1901 402.2 71.6801C402.66 70.6301 403.57 69.83 404.68 69.53C405.95 69.19 407.35 69.5 408.26 70.45C411.11 73.41 410.95 80.2901 413.23 83.1201C414.71 84.9501 417.95 85.4801 420.03 86.2901C421.46 86.85 423.03 87.4401 424.13 88.57C425.67 90.15 425.3 92.05 424.01 93.25H424.02Z"
        fill={fill}
      />
      <path
        d="M427.24 139.58C427 139.95 423.32 140.3 421.96 141.51C419.56 143.65 420.23 150.71 416.35 150.35C413.72 150.11 414 144.37 412.28 142.45C410.56 140.53 405.33 140.63 405.33 138.08C405.33 135.53 410.88 135.13 412.53 133.34C414.26 131.47 413.83 128.31 415.33 126.26L416.93 125.83C419.91 126.49 419.45 131.78 421.01 133.72C422.38 135.42 429.76 135.65 427.23 139.58H427.24Z"
        fill={fill}
      />
      <path
        d="M38.73 218.86C36.05 221.41 31.8 220.14 29.4 222.28C25.15 226.06 26.35 238.55 19.48 237.91C14.82 237.48 15.32 227.34 12.28 223.94C9.27001 220.57 -0.00999192 220.72 8.07562e-06 216.22C0.0100081 211.72 9.81001 211.01 12.73 207.84C15.33 205.03 15.17 200.57 16.7 197.06C17.16 196.01 18.07 195.21 19.18 194.91C20.45 194.57 21.85 194.88 22.76 195.83C25.61 198.79 25.45 205.67 27.73 208.5C30.16 211.5 44.71 213.17 38.73 218.86Z"
        fill={fill}
      />
      <path
        d="M66.1699 45.2501C64.0299 46.9501 59.2399 46.5301 56.8399 48.6701C52.5899 52.4501 53.7899 64.9401 46.9199 64.3001C42.2599 63.8701 42.7599 53.7301 39.7199 50.3301C36.7099 46.9601 27.4299 47.1101 27.4399 42.6101C27.4499 38.1101 37.2499 37.4001 40.1699 34.2301C42.7699 31.4201 42.6099 26.9601 44.1399 23.4501C44.5999 22.4001 45.5099 21.6001 46.6199 21.3001C47.8899 20.9601 49.2899 21.2701 50.1999 22.2201C53.0499 25.1801 52.8899 32.0601 55.1699 34.8901C57.5999 37.8901 72.6299 40.1001 66.1699 45.2501Z"
        fill={fill}
      />
      <path
        d="M46.74 257.69C46.5 258.06 42.82 258.41 41.46 259.62C39.06 261.76 39.73 268.82 35.85 268.46C33.22 268.22 33.5 262.48 31.78 260.56C30.07 258.65 24.83 258.74 24.83 256.19C24.83 253.65 30.38 253.24 32.03 251.45C33.52 249.84 33.41 247.27 34.31 245.28C34.57 244.71 35.09 244.3 35.69 244.14C36.33 243.97 37.05 244.06 37.55 244.5C39.33 246.08 39.19 250.17 40.52 251.82C41.89 253.52 49.27 253.75 46.74 257.68V257.69Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_19465_95338">
        <rect width="427.76" height="396.66" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ProjectionsIcon;
